// ============================================
// FILE 5: /frontend/src/api/priceAlerts.api.js
// PURPOSE: Price Alerts API endpoints
// ============================================

import apiClient from './client.js';

export const priceAlertsAPI = {
  // Create price alert
  createPriceAlert: async (listingId, alertThreshold = 5.0) => {
    const response = await apiClient.post('/price-alerts', {
      listingId,
      alertThreshold,
    });
    return response.data;
  },

  // Get user's price alerts
  getUserPriceAlerts: async (userId) => {
    const response = await apiClient.get(`/price-alerts/user/${userId}`);
    return response.data;
  },

  // Delete price alert
  deletePriceAlert: async (alertId) => {
    const response = await apiClient.delete(`/price-alerts/${alertId}`);
    return response.data;
  },
};